var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":("" + _vm.api_url + (_vm.image.url)),"alt":_vm.image.alternativeText,"title":_vm.image.caption}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }